import { render, staticRenderFns } from "./ImageUpload.vue?vue&type=template&id=132b223b&scoped=true"
import script from "./ImageUpload.vue?vue&type=script&lang=js"
export * from "./ImageUpload.vue?vue&type=script&lang=js"
import style0 from "./ImageUpload.vue?vue&type=style&index=0&id=132b223b&prod&scoped=true&lang=css"
import style1 from "./ImageUpload.vue?vue&type=style&index=1&id=132b223b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "132b223b",
  null
  
)

export default component.exports